import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {

	init() {
		gsap.core.globals('ScrollTrigger', ScrollTrigger);

		gsap.from('.interior-image', {
			scrollTrigger: {
				scrub: true,
				trigger: '.interior-image',
				end: 'top center',
			},
			scale: 0.3,
			ease: 'sine.out',
		});
	},

};
